/**
 * スクロールトリガーアニメーション
 * js-scroll-trigger クラスを持つ要素が画面に表示されたら is-scroll-active を付与
 *
 * 使用例：
 * <div class="js-scroll-trigger fade-up">...</div>
 * <div class="js-scroll-trigger fade-in">...</div>
 */

export function initScrollTrigger() {
  const triggers = document.querySelectorAll('.js-scroll-trigger');

  if (triggers.length === 0) return;

  // Intersection Observer のオプション
  // rootMargin の bottom: -20% で画面下から20%位置をトリガー
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -20% 0px',
    threshold: 0,
  };

  // Intersection Observer コールバック
  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-scroll-active');
        // 一度アニメーションが発火したら監視を解除
        observer.unobserve(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  triggers.forEach((trigger) => {
    observer.observe(trigger);
  });
}
